import React from 'react';
import { array, func, number, string, oneOfType, object, bool } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { equals, allPass, has } from 'ramda';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { Icon } from '@material-ui/core';

import { mapIndexed } from '../../../utils/helpers';

import useStyles from './styles';

const styles = {
  blackColor: {
    color: 'black',
  },
  whiteColor: {
    color: 'white',
  },
  blueColor: {
    color: '#00238E',
  },
};

const MultiPicker = ({
  className,
  content,
  onChange,
  option = 12,
  selected,
  buttonContainerStyle,
  iconStyle,
  textStyle,
  spacing = 2,
  justify = 'flex-start',
  wrap = 'wrap',
  multi = false,
  size = 'medium',
  downSized = false,
}) => {
  const classes = useStyles();
  const isIntl = allPass([has(['id']), has(['defaultMessage'])]);
  const isSelected = multi ? value => selected?.[value] : value => equals(selected, value);

  return (
    <Grid container className={className} spacing={spacing} justify={justify} wrap={wrap}>
      {mapIndexed(
        ({ name, value, image, xs }, index) => (
          <Grid item key={index} xs={xs || option} className={classes.fullWidth}>
            <Button
              className={`${isSelected(value) ? null : classes.selected}`}
              style={
                textStyle &&
                (isSelected(value) ? { ...styles.whiteColor, ...textStyle } : { ...styles.blackColor, ...textStyle })
              }
              color="primary"
              fullWidth
              onClick={() => onChange(value)}
              variant="contained"
              classes={{
                root: classes.buttonStyle,
              }}
              name={typeof value === 'boolean' ? name?.defaultMessage : value}
              size={downSized ? 'small' : size}
            >
              <div style={buttonContainerStyle}>
                {image && (
                  <Icon
                    component={image}
                    style={
                      isSelected(value) ? { ...styles.whiteColor, ...iconStyle } : { ...styles.blueColor, ...iconStyle }
                    }
                  />
                )}
                {isIntl(name) ? <FormattedMessage id="" {...name} /> : name}
              </div>
            </Button>
          </Grid>
        ),
        content,
      )}
    </Grid>
  );
};

MultiPicker.propTypes = {
  content: array,
  className: string,
  onChange: func,
  option: number,
  selected: oneOfType([bool, string, object]),
  buttonContainerStyle: object,
  iconStyle: object,
  textStyle: object,
  spacing: number,
  justify: string,
  wrap: string,
  multi: bool,
  size: string,
  downSized: bool,
};

export default MultiPicker;
